import { render, staticRenderFns } from "./InputEditor.vue?vue&type=template&id=081902ca"
import script from "./InputEditor.vue?vue&type=script&lang=js"
export * from "./InputEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports